import { render, staticRenderFns } from "./Qiancai.vue?vue&type=template&id=11046925&"
import script from "./Qiancai.vue?vue&type=script&lang=js&"
export * from "./Qiancai.vue?vue&type=script&lang=js&"
import style0 from "./Qiancai.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports